import { useMutation } from "@tanstack/react-query";
import { useCallback, useState } from "react";

import { setExtendedField, uploadFile } from "./fetch";
import extendedFieldKeys from "./keys";

const useUploadFile = () => {
  const [progressPercentage, setProgressPercentage] = useState(0);

  const onUploadProgress = useCallback(({ loaded, total }) => {
    setProgressPercentage(loaded / total);
  }, []);

  return {
    ...useMutation({
      mutationFn: (formData) => uploadFile(formData, onUploadProgress),
    }),
    progressPercentage,
  };
};

const useSetExtendedField = (onSuccess) => {
  const [errorMessage, setErrorMessage] = useState("");

  const clearErrorMessage = useCallback(() => {
    setErrorMessage("");
  }, []);

  const mutation = useMutation({
    mutationFn: async ({ userID, formData }) => {
      if (!userID) {
        setErrorMessage(
          "Oops! Something went wrong. Contact help@flocknote.com if this keeps happening."
        );
        return;
      }
      clearErrorMessage();
      return await setExtendedField(userID, formData);
    },
    mutationKey: extendedFieldKeys.saveFields(),
    onSuccess: (resp) => {
      onSuccess && onSuccess(resp);
    },
    onError: (error) => {
      setErrorMessage(error?.message || error);
    },
  });

  return { ...mutation, errorMessage, clearErrorMessage };
};

export { useUploadFile, useSetExtendedField };
